module.exports = __webpack_public_path__ + "img/1F1FB-1F1E8.c0dce162.svg";